import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import InputBase from "../../../../common/components/form/InputBase.jsx";
import * as API from "../../../lib/api.js";
import ButtonBase from "../../../../common/components/form/ButtonBase.jsx";
import { toast } from "react-toastify";

const InputClientId = "ClientId";
const InputSecretKey = "SecretKey";

let SaveTimeout;
export default function PaymentPaypal(props) {
    const { t } = useTranslation();
    const params = useParams();
    const {
        set,
        variables,
        variables: { PaymentSystem },
    } = props;

    const [settings, setSettings] = React.useState({ [InputClientId]: "", [InputSecretKey]: "" });
    const [testing, setTesting] = React.useState(false);

    React.useEffect(() => {
        if (!PaymentSystem) {
            set({ ...variables, PaymentSystem: "paypal", PaymentSettingUp: false });
        }
    }, [PaymentSystem]);

    React.useEffect(() => {
        Load();
    }, []);

    async function Load() {
        const response = await API.ProjectPaypalGet(params.id);
        setSettings({ ...settings, ...(response?.settings || {}) });
    }

    function onChange(event) {
        settings[event.target.name] = event.target.value.trim();
        setSettings({ ...settings });

        SaveTimeout && clearTimeout(SaveTimeout);
        SaveTimeout = setTimeout(async () => {
            const response = await API.ProjectPaypalSet(params.id, settings);
            setSettings({ ...settings, ...(response?.settings || {}) });
        }, 500);
    }

    async function onSetupClick() {
        setTesting(true);

        const response = await API.ProjectPaypalSetup(params.id);
        console.warn("[onSetupClick()] response:", response);

        if (response?.error && response?.status) {
            toast.warn(t(response.status), { autoClose: 20000 });
        } else if (response?.status) {
            toast.success(t(response.status));
            // response?.link && location.assign(response.link);
            // response?.link && open(response.link, "_blank");
        }

        setTesting(false);
    }

    return (
        <div className="grid-gap-20 align-content-start text-left">
            <div>
                <h3>{t("WizardECommercePayPalAPICredentials")}:</h3>
            </div>

            <InputBase
                onChange={onChange}
                name={InputClientId}
                value={settings[InputClientId] || ""}
                placeholder={t("WizardECommerceAPIPayPalClientID")}
                fullWidth
                asPassword
                autoComplete="new-password"
                disabled={testing}
            />

            <InputBase
                onChange={onChange}
                name={InputSecretKey}
                value={settings[InputSecretKey] || ""}
                placeholder={t("WizardECommerceAPIPayPalSecretKey")}
                fullWidth
                asPassword
                autoComplete="new-password"
                disabled={testing}
            />

            <div className="grid-gap-10">
                <p>{t("To connect your PayPal account please follow this simple instruction:")}</p>

                <ol>
                    <li>
                        <div dangerouslySetInnerHTML={{ __html: t("ECommercePayPalInstructionStepCreateApp") }} />
                    </li>

                    <li>
                        <div>
                            {t("ClickTo")}{" "}
                            <ButtonBase
                                link
                                onClick={onSetupClick}
                                style={{ color: "#000000" }}
                                disabled={!settings[InputClientId] || !settings[InputSecretKey] || testing}
                            >
                                {/* {t("InstallNTest")} */}
                                {t("Install")}
                            </ButtonBase>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    );
}
